export default {
      id: "huge-export-attachment-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#huge-export-attachment",
      toString: function () {
        return this.url;
      }
    }